import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@heroui/react';
import { useAuth } from '../../hooks/useAuth';
import { authDebug } from '../../lib/auth-debug';

export default function AdminRoute({ children }: { children: ReactNode }) {
  const { userDoc, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!userDoc) {
    return <Navigate to="/login" replace />;
  }

  if (!userDoc.isGlobalAdmin) {
    authDebug('AdminRoute bloqueou acesso — usuário não é admin global', {
      email: userDoc.email,
      uid: userDoc.uid,
      isGlobalAdmin: userDoc.isGlobalAdmin,
      path: window.location.pathname,
    });
    return <Navigate to="/404" replace />;
  }

  authDebug('AdminRoute liberou acesso', {
    email: userDoc.email,
    path: window.location.pathname,
  });

  return <>{children}</>;
}
